document.addEventListener('DOMContentLoaded', function() {
  var facades = document.querySelectorAll('.youtube-facade');
  
  facades.forEach(function(facade) {
    facade.addEventListener('click', function() {
      var videoId = facade.getAttribute('data-video-id');
      var iframe = document.createElement('iframe');
      
      // Constrói o novo iframe
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '1');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0'); 
      
      // Define o aspecto (importante)
      iframe.style.aspectRatio = '16 / 9';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      
      // Adiciona o iframe e remove o conteúdo antigo
      facade.innerHTML = ''; // Limpa o thumbnail e o botão
      facade.appendChild(iframe);
      facade.classList.add('active');
    });
  });
});